import React from "react";
import HeadShot from "../../src/assets/HeadShot.jpeg";
import SocialMedia from "../components/SocialMedia";

const Footer = () => {
  return (
    <footer className="footer mt-5 pt-5">
    <div className="text-center mb-4">
      <a
        href="https://www.linkedin.com/in/pawel-jaskolski-995323b3/"
        rel="noopener noreferrer"
        target="_blank"
      >
        <img
          className="headshot me-2"
          src={HeadShot}
          alt="Headshot Avatar"
        />
      </a>
      <em><small>Crafted with care by me, Pawel Jaskolski.</small></em>
    </div>
    <SocialMedia />
  </footer>
  );
};

export default Footer;